import React from "react"

export default function Card(props) {
  return (
    <div className="card profile-card-5">
      <div className="card-img-block">
        <img className="card-img-top" src={props.img} alt="Card image cap" />
      </div>
      <div className="card-body pt-0">
        <h5 className="card-title">{props.name}</h5>
        <p className="card-text">{props.description}</p>
        {props.tools ? (
          <p
            style={{
              backgroundColor: "#1C1740",
              color: "white",
              textAlign: "center",
            }}
          >
            {props.tools}
          </p>
        ) : null}
        {props.link !== "pending" ? (
          <a href={props.link} target="_blank" className="btn btn-primary">
            {props.buttonText ? props.buttonText : "View Certification"}
          </a>
        ) : (
          <p style={{ fontWeight: "bold", color: "#48d94e" }}>Pending</p>
        )}
      </div>
    </div>
  )
}
